import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { CompanyEntitlementFacade } from "../../billing/store/company-entitlement.facade";

export const nedapAccessGuard: CanActivateFn = () => {
    const entitlement = inject(CompanyEntitlementFacade);
    const router = inject(Router);
    return entitlement.hasNedapAccess()
        ? true
        : router.createUrlTree(["/dashboard"]);
};
